// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/open-app-store/open-app-store.component.scss
// module id = 421
// module chunks = 0